import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

import { IndicatorComponent } from "./indicator/indicator.component";
import { MarkComponent } from "./mark/mark.component";

@NgModule({
	imports: [CommonModule, TranslateModule, MatTooltipModule],
	declarations: [IndicatorComponent, MarkComponent],
	exports: [IndicatorComponent, MarkComponent],
})
export class IndicatorModule {}
